export default __webpack_public_path__ + "vendor/ckeditor/plugins/iframe/dialogs/iframe.js";